import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { privatePagesGuard } from '@core/guards/auth/private-pages.guard';
import { ProductService } from '@core/product/product.service';
import { AUTH_ROUTES } from '@features/auth/auth.routes';
import { PageNotFoundComponent } from '@features/page-not-found.component';
import { APP_SLUGS } from '@routes/routes.types';
import { TWX_AUTH_ROUTES } from '@twinnyx/features/auth/auth.routes';
import { TWX_STRIPE_RETURN_PATH, twxStripeReturn } from '@twinnyx/shared/stripe/stripe-return';

export const APP_ROUTES: Routes = [
    {
        path: APP_SLUGS.AUTH,
        // TwinnyX's pages first (login, password, verify); Twinny's still serve the rest.
        children: [...TWX_AUTH_ROUTES, ...AUTH_ROUTES],
    },
    { path: APP_SLUGS.NOT_FOUND, title: 'Page not found', component: PageNotFoundComponent },
    // Back from an embedded Stripe session (twinny-api's return page): to the screen that opened it.
    { path: TWX_STRIPE_RETURN_PATH, pathMatch: 'full', redirectTo: twxStripeReturn },
    {
        // TwinnyX: its root routes (shell + sections), see src/app/twinnyx/README.md.
        path: '',
        canActivate: [privatePagesGuard],
        loadChildren: () => import('@twinnyx/twinnyx.routes').then(m => m.TWINNYX_ROUTES),
    },
    { path: '**', redirectTo: () => inject(ProductService).homeUrl() },
];
